<template>
  <v-dialog hide-overlay v-model="newLogin" max-width="500px">
    <v-card style="height: 100%; padding: 15px">
      <div class="loader" v-if="loading">
        <Loader />
      </div>
      <v-container v-else>
        <vue-markdown v-if="welcomeText" :source="welcomeText">
        </vue-markdown>

        <button class="get-started__button" @click="hideModal">
          Continue
        </button>
      </v-container>
    </v-card>
  </v-dialog>
</template>

<script>
import get from 'lodash/get';
import VueMarkdown from 'vue-markdown';

import { getSystemText } from '@/api';

import Loader from '@/components/Loader';

export default {
  components: {
    VueMarkdown,
    Loader,
  },
  data() {
    return {
      loading: false,
      welcomeText: null,
      taskId: null,
    };
  },
  computed: {
    newLogin() {
      return this.$store.getters['auth/isNewUser'];
    },
  },
  methods: {
    hideModal() {
      this.$store.dispatch('auth/onboardingComplete');
      this.$router.push({ name: 'TaskDetails', params: { id: this.taskId } });
    },
    fetchSystemText: async function fetchSystemText() {
      this.loading = true;
      const userToken = this.$store.getters['auth/userToken'];
      const { data } = await getSystemText(userToken, 'welcome');
      this.welcomeText = get(data, '[1].data.details.text');
      this.taskId = get(data, '[1].data.details.task_id');
      this.loading = false;
    },
  },
  mounted() {
    this.fetchSystemText();
  },
};
</script>

<style scoped lang="scss">
@import "~styles/shared.scss";


.get-started__button {
  width: 100%;
  background: $primary;
  padding: 10px 20px;
  text-decoration: none;
  color: white;
  font-weight: bold;
  border-radius: 32px;

  display: flex;
  justify-content: center;
  margin-top: 35px;
}

.loader {
  width: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
}
</style>




// WEBPACK FOOTER //
// src/components/Welcome.vue